/**
 * AOV Lever Coordinator
 *
 * Reads [data-aov-lever] elements on page load, determines the
 * highest-priority visible lever per surface, and hides lower-priority levers.
 *
 * Priority order (highest first):
 *   1. bundle   (style-it-with)
 *   2. upsell   (related-products)
 *   3. threshold (cart-conversion-summary — separate surface, never competes)
 */
(function () {
  'use strict';

  var PRIORITY = {
    bundle: 1,
    upsell: 2,
    threshold: 3
  };

  function coordinateLevers() {
    var levers = document.querySelectorAll('[data-aov-lever]');
    if (!levers.length) return;

    // Group levers by surface
    var surfaces = {};
    for (var i = 0; i < levers.length; i++) {
      var el = levers[i];
      var surface = el.getAttribute('data-aov-surface') || 'unknown';
      if (!surfaces[surface]) surfaces[surface] = [];
      surfaces[surface].push(el);
    }

    // For each surface, show only the highest-priority lever
    var surfaceKeys = Object.keys(surfaces);
    for (var s = 0; s < surfaceKeys.length; s++) {
      var key = surfaceKeys[s];
      var group = surfaces[key];
      if (group.length <= 1) continue;

      // Sort by priority (lowest number = highest priority)
      group.sort(function (a, b) {
        var pa = PRIORITY[a.getAttribute('data-aov-lever')] || 99;
        var pb = PRIORITY[b.getAttribute('data-aov-lever')] || 99;
        return pa - pb;
      });

      // Check if highest-priority lever has content
      var winner = group[0];
      var winnerHasContent = winner.querySelector('.style-with__actions, .product-grid li, .grid__item');

      for (var j = 1; j < group.length; j++) {
        if (winnerHasContent) {
          group[j].style.display = 'none';
          group[j].setAttribute('data-aov-suppressed', 'true');
        }
      }

      if (winnerHasContent) {
        winner.setAttribute('data-aov-active', 'true');
      }
    }
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', coordinateLevers);
  } else {
    coordinateLevers();
  }

  // Also run when product-recommendations custom element loads content
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        coordinateLevers();
      }
    }
  });

  var recsContainer = document.querySelector('product-recommendations[data-aov-lever]');
  if (recsContainer) {
    observer.observe(recsContainer, { childList: true, subtree: true });
  }
})();
